import React, { FC } from 'react';
import { AddMilestoneAttachmentError } from '@bechtel/types';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  ModalClose,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { AddMilestoneAttachmentErrorProps } from './types';
import { FooterButtonStyled } from './styled';

const getErrorMessage = (error: AddMilestoneAttachmentErrorProps['error']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case AddMilestoneAttachmentError.MILESTONE_CONFIG_NOT_FOUND:
      return <Trans>Milestone configuration not found.</Trans>;
    case AddMilestoneAttachmentError.MISSING_REQUIRED_PERMISSION:
      return <Trans>You have no required permission to add photos.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

export const AddAttachmentError: FC<AddMilestoneAttachmentErrorProps> = ({ error, close }) => {
  return (
    <Modal visible size={ModalSize.DEFAULT} data-testid="update-user-error" style={{ width: '552px', height: '275px' }}>
      <ModalHeader title={t`Add Photos Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(error)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <FooterButtonStyled appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans>Close</Trans>
            </FooterButtonStyled>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
